import type { ActiveJob } from '@/stores/active-jobs-store'

/** Where a job links: its section, else its document, else its bid. Shared by the header tray and Home's "Working on it". */
export function buildSectionLink(job: ActiveJob): string | null {
  if (!job.bidId) return null
  // Fill runs work on a whole workbook or form: open its fill page.
  if (job.artifactId && job.jobType === 'form_fill') {
    return `/app/bids/${job.bidId}/responses/${job.artifactId}/form`
  }
  if (job.artifactId && job.jobType === 'schedule_fill') {
    return `/app/bids/${job.bidId}/responses/${job.artifactId}/schedule`
  }
  if (job.artifactId && job.sectionKey) {
    return `/app/bids/${job.bidId}/responses/${job.artifactId}/sections/${job.sectionKey}`
  }
  if (job.artifactId) {
    return `/app/bids/${job.bidId}/responses/${job.artifactId}`
  }
  return `/app/bids/${job.bidId}`
}
